import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { IJobProgress } from '@app/core/job-status/models/job-progress.model';
import { JobStatusService } from '@app/core/job-status/services/job-status.service';
import { NotificationService } from '@app/core/notifications/services/notification.service';

import { JobStatusDetailsPopupComponent } from '../job-status-details-popup/job-status-details-popup.component';

const FIVE_SECONDS = 5000;
const THIRTY_SECONDS = 30000;

@Component({
  selector: 'cnc-job-status-link',
  templateUrl: './job-status-link.component.html',
  styleUrls: ['./job-status-link.component.scss'],
})
export class JobStatusLinkComponent implements OnInit, OnDestroy {
  #pollTimeout :NodeJS.Timeout;

  constructor(
    private jobStatusService :JobStatusService,
    private dialog :MatDialog,
    private notificationService :NotificationService,
  ) {}

  overallProgress$ :Observable<IJobProgress> = this.jobStatusService.progress$;

  ngOnInit() :void {
    this.jobStatusService.getJobs();
    this.#pollTimeout = setTimeout(() => this.#getJobs(), FIVE_SECONDS);
  }
  ngOnDestroy() :void {
    clearTimeout(this.#pollTimeout);
  }

  #getJobs() :void {
    this.notificationService.init();

    if (this.jobStatusService.getJobCount('activeJobs') === 0) {
      clearTimeout(this.#pollTimeout);
      this.#pollTimeout = setTimeout(() => this.#getJobs(), THIRTY_SECONDS);
    } else {
      this.jobStatusService.getJobs();
      clearTimeout(this.#pollTimeout);
      this.#pollTimeout = setTimeout(() => this.#getJobs(), FIVE_SECONDS);
    }
  }

  viewDetails() {
    this.dialog.open(JobStatusDetailsPopupComponent, {
      data: {},
      width: '850px',
    });
  }
}
